import { useAppSelector } from "../../../../hooks";
import { selectCurrentUser } from "../../../authentication/services";
import { checkHasPermission } from "../../../authentication/utils";

const useKioskPermission = () => {
    const currentUser = useAppSelector(selectCurrentUser);
    const hasPermission = checkHasPermission({
        role: currentUser?.role,
        resource: "kioskSettings",
        action: "update",
    });

    return { hasPermission };
};

export default useKioskPermission;
